import React, { useState, useEffect } from 'react';
import { FaBell, FaSearch, FaCaretDown, FaCaretUp, FaCog,FaEdit,  FaTimes } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import HighchartsGraph from './Highcharts';
import Sidebar from './Sidemenu';


const AssetDashboard = () => {
  const navigate = useNavigate();
  const [showAccountOptions, setShowAccountOptions] = useState(false);
  const [assetData, setAssetData] = useState([]);
  const [detailsVisible, setDetailsVisible] = useState(false);
  const [selectedTitleDetails, setSelectedTitleDetails] = useState({});
  
  useEffect(() => {
    const fetchAssetData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/getAllAssetData`);

        if (response.ok) {
          const data = await response.json();
          setAssetData(data);
        } else {
          console.error('Failed to fetch asset data:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error fetching asset data:', error);
      }
    };

    fetchAssetData();
  }, []);

  const toggleAccountOptions = () => {
    setShowAccountOptions(!showAccountOptions);
  };

  const location = useLocation();
  const title = new URLSearchParams(location.search).get('title');

 

  const handleEdit = () => {
    // Navigate to assets page when the "Edit" button is clicked
    navigate('/assets'); // Update '/assets' with the actual path you want to navigate to
  };

 
  const handleCancel = () => {
    navigate('/Components');
    
  };

  const handleDetails = () => {
    const selectedTitle = assetData.find((asset) => asset.title === title);

    if (selectedTitle) {
      setDetailsVisible(!detailsVisible);
      setSelectedTitleDetails(selectedTitle);
    } else {
      console.warn(`Details not found for title: ${title}`);
    }
  };

  return (
    <div style={{ display: 'flex' }}>
    
    <Sidebar />
    <div className="content-container" style={{ marginLeft: '10px', marginTop: '15px', paddingLeft: '3px', paddingRight: '10px', width: '1360px', height: 'auto', display: 'flex', flexDirection: 'column' }}>
      {/* First rectangle */}
      <div style={{ paddingLeft: '10px', paddingRight: '10px', width: '1347px', height: '90px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',border: '1px solid #ccc' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FaBell style={{ fontSize: '24px', marginRight: '20px' }} />
          <FaSearch style={{ fontSize: '24px' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* Profile Box */}
          <div style={{ display: 'flex', alignItems: 'center', position: 'relative',paddingRight:'30px' }}>
            <div style={{ border: '1px solid #ccc', borderRadius: '50%', width: '40px', height: '40px', overflow: 'hidden', marginRight: '10px' }}>
              {/* Add your profile image or icon here */}
            </div>
            <span style={{ marginRight: '2px',marginLeft:'10px' }}>EPICX</span>
            <div style={{ cursor: 'pointer' }} onClick={toggleAccountOptions}>
              {showAccountOptions ? <FaCaretUp /> : <FaCaretDown />}
            </div>
            {showAccountOptions && (
              <div style={{ position: 'absolute', top: '100%', right: '0', background: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '8px', zIndex: '1' }}>
                <p>Account</p>
                <p>Logout</p>
              </div>

              
            )}
          </div>

          {/* Settings Icon */}
          <div style={{ cursor: 'pointer', marginLeft: '-10px' }}>
            <FaCog style={{ fontSize: '24px', marginLeft: '4px', marginRight: '20px' }} />
          </div>
        </div>
        {/* Additional content or components can be added here */}
      </div>
      {/* Second rectangle */}
<div style={{ paddingLeft: '10px', paddingRight: '10px', width: '1347px', height: '110px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',}}>
  <div style={{ display: 'flex', alignItems: 'center', fontSize: '30px', marginLeft: '30px' }}>
    <span>{title}</span>
  </div>
  <div>
    {/* Edit Button */}
    <button className="btn btn-white mt-3 mr-2" style={{ border: '1px solid #ccc', marginRight: '20px' }} onClick={handleEdit}>
      <FaEdit className="" style={{ color: '#007bff' }} /> Edit
    </button>
    {/* Cancel Button */}
    <button className="btn btn-white mt-3" style={{ border: '1px solid #ccc' }} onClick={handleCancel}>
      <FaTimes className="" style={{ color: 'red' }} /> Cancel
    </button>
  </div>
</div>

<div className="container">
  <div className="row">
    <div className="col-md-6" style={{ marginLeft: '900px', marginTop: '30px' }}>
      <h5 style={{ marginBottom: '10px', fontWeight: 'bold',width:'5%' }}>Download URL</h5>
      <input
        type="text"
        className="form-control"
        placeholder="Enter URL"
        style={{ width: '60%' }}
      />
      <div className="row justify-content-center">
    <div className="col-md-6">
    <hr style={{ width: '70%', marginTop: '50px',marginLeft:'-70px' }} />
    </div>
    </div>
    </div>
  </div>
</div>

<div className="row">
  <div className="col-md-6" style={{ marginLeft: '800px', marginTop: '30px', textAlign: 'center' }}>
    <h5 style={{ marginBottom: '10px', fontWeight: 'bold' }}>Recent Activity</h5>
    <p>Created By EpicX</p>
    <p>{new Date().toLocaleString()}</p>
  </div>
</div>










      {/* Third rectangle */}
      <div style={{ /* ... your existing styles */ }}>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: '30px', marginTop:'-350px',marginLeft: '-20px' }}>
          {/* Details Button */}
          <button className="btn btn-white mt-3" style={{ border: '1px solid #ccc',marginTop:'-300px' }} onClick={handleDetails}>
            {detailsVisible ? (
              <span>
                Details <FaCaretUp/>
              </span>
            ) : (
              <span>
                Details <FaCaretDown />
              </span>
            )}
          </button>
        </div>
      </div>
      {/* Display details when the button is clicked */}
      {detailsVisible && (
        <div className="asset-details" style={{ marginBottom: '10px',marginTop:'-250px'}}>
          
          <table className="table" style={{ width: '30%', margin: '10px', height: '3px', border: '1px solid black' }}>
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(selectedTitleDetails).map(([key, value]) => (
                // Exclude 'storageLocation' from displayed details
                key !== 'storageLocation' && (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>{typeof value === 'boolean' ? value.toString() : value}</td>
                  </tr>
                )
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Display the HighchartsGraph outside the conditional rendering */}
      <div style={{ flex: 1,marginTop:'-205px' ,width:'80%',height:'1200px'}}>
        <HighchartsGraph />
      </div>
    </div>
    </div>
  );
};

export default AssetDashboard;
